import { createContext, useContext } from 'react'

export const DeferredReviewContext = createContext<{
  deferred: ReadonlySet<string>
  defer: (key: string) => void
} | null>(null)

export function useDeferredReview() {
  const context = useContext(DeferredReviewContext)
  if (!context) throw new Error('useDeferredReview requires DeferredReviewProvider')
  return context
}
